import Axios from 'axios';
import { RealCurrentUser } from '../user/realCurrentUser';
import Leanplum from 'leanplum-sdk';
import { ICheckAccountExist } from './constants/WebpushServiceResponses';
import { CurrentUser } from '../user/currentUser';

type ReqNewTokenDataType = {
    platform: string,
    signature: string
    token: string,
    suid: string
};


export class WebpushServiceApi {
    static async saveUserToken(token: string) {
        try {
            const currentUser = CurrentUser.getInstance();
            const requestData: ReqNewTokenDataType = {
                platform: window.app.config.user_browser.name,
                signature: currentUser.getAuthToken(),
                suid: currentUser.getSuid(),
                token: token
            };
            const request = await Axios.post(`${window.app.config.web_push_service.url}account/new/`, requestData);
            if (request.data.result.isAccountAdded) {
                console.log('[WEB-PUSH] New account is success added', request.data);
                return;
            }

            console.error('[WEB-PUSH] New account is not added');
        } catch (exception) {
            console.error('[WEB-PUSH] Failed on add new account', exception);
        }
    }

    static async setAccountStateInWebpushService(state: boolean): Promise<{isUpdated: boolean}> {
        try {
            const currentUser = CurrentUser.getInstance();
            const requestData = {
                platform: window.app.config.user_browser.name,
                signature: currentUser.getAuthToken(),
                suid: currentUser.getSuid(),
                state: state
            };
            const request = await Axios.post(`${window.app.config.web_push_service.url}account/state/`, requestData);
            return request.data.result;
        } catch (error) {
            console.error('Fail request to web_push_service at set state', error);
            return {
                isUpdated: false
            };
        }
    }

    static async isActiveAccount(): Promise<boolean> {
        try {
            const state = await this.getAccountStateInWebpushService();
            return state.accountAlreadyExist;
        } catch (exception) {
            console.error('Fault on check account in web push service', exception);
            window.Sentry.captureException(exception);
            return false;
        }
    }

    static async getPushSubscriptionState(): Promise<boolean|string> {
        try {
            const state = await this.getAccountStateInWebpushService();
            return state.lastUpdatedDate;
        } catch (exception) {
            console.log('Fault on get account subscription in web push service', exception);
            window.Sentry.captureException(exception);
            return false;
        }
    }

    static checkNotificationsInBrowserGranted(): boolean {
        return Leanplum.isWebPushSupported();
    }

    private static async getAccountStateInWebpushService(): Promise<ICheckAccountExist> {
        console.log('FCM try send request on check account');
        const response = await Axios.post(`${window.app.config.web_push_service.url}account/check/`, {
            platform: window.app.config.user_browser.name,
            suid: RealCurrentUser.getInstance().getSuid()
                .toString()
        });
        return response.data.result;
    }
}
